export default function normalisePromotionCode (promotionCode) {
  return promotionCode && promotionCode.replace(/^PP/i, '')
}
